import styled from 'styled-components';
import { Title, LARGE, EXTRA_LARGE } from '@minerva-analytics/pantheon';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 90%;
  align-items: center;
  justify-content: center;
  margin: 5rem auto 0 auto;

  @media (max-width: ${LARGE}) {
    flex-direction: column;
    text-align: left;
    margin: 0 auto;
  }
`;

const HeroContainer = styled.div`
  margin: 0 auto;
  max-width: 700px;

  @media (max-width: ${EXTRA_LARGE}) {
    max-width: 500px;
  }

  @media (max-width: ${LARGE}) {
    text-align: left;
    max-width: unset;
  }
`;

const HomeTitle = styled(Title)`
  @media (max-width: ${LARGE}) {
    text-align: left;
  }
`;

const ImageContainer = styled.div`
  margin: 0 auto;
  @media (max-width: ${LARGE}) {
    display: flex;
    justify-content: center;
  }
  
`;

const HomeImage = styled.img`
  width: 35rem;
  height: 100%;
  object-fit: cover;

  @media (max-width: ${EXTRA_LARGE}) {
    width: 30rem;
  }

  @media (max-width: ${LARGE}) {
    margin: 1rem 0 2rem 0; 
    width: 80%;
  }
`;

export {
  HeroContainer,
  HomeContainer,
  ImageContainer,
  HomeTitle,
  HomeImage
};
